import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from '@tanstack/react-query';
import { CompanySettings } from '~/common/entities/CompanySettings/CompanySettingsTypes';
import { unwrap } from '../common/apiCommons';
import axios, { AxiosError } from 'axios';

const CompanySettingsQueries = {
  async getCompanySettings() {
    const res = await axios.get<CompanySettings>('/company/settings/');
    return unwrap(res);
  },
};

const CompanySettingsMutations = {
  async updateCompanySettings(editedSettings: CompanySettings) {
    const res = await axios.put<CompanySettings>(
      '/company/settings/',
      editedSettings,
    );
    return unwrap(res);
  },
};

const CompanySettingsHooks = {
  useCompanySettings<T = CompanySettings>(
    options?: UseQueryOptions<CompanySettings, AxiosError, T>,
  ) {
    const queryClient = useQueryClient();
    const result = useQuery({
      queryKey: ['COMPANY_SETTING'],
      queryFn: () => CompanySettingsQueries.getCompanySettings(),
      ...options,
    });
    const QueryResultAndInvalidate: [typeof result, () => Promise<void>] = [
      result,
      () => queryClient.invalidateQueries(['COMPANY_SETTING']),
    ];
    return QueryResultAndInvalidate;
  },
  useUpdateCompanySettings() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: CompanySettingsMutations.updateCompanySettings,
      async onSuccess() {
        await queryClient.invalidateQueries(['COMPANY_SETTING']);
      },
    });
  },
};

const CompanySettingsApi = {
  queries: CompanySettingsQueries,
  mutations: CompanySettingsMutations,
  hooks: CompanySettingsHooks,
};

export default CompanySettingsApi;
